/*eslint camelcase: ["error", {allow: [""]}]*/

// import { AnalyticsUserActionEventObjectException } from '../errors/analyticsError';
// import Logger from '../utils/analyticsLogger';
import DataObject from './DataObject';

export default class UserActionEventObject extends DataObject {
  constructor(data) {    
    if (data.eventtype) {
      super(data.eventype, data);
    } else {
      super('uaevent', data);
    }
      
delete this.result.dontTrigger; 
if (data.isYext) {
  const inputElement = document.querySelector('.yxt-SearchBar-input');
  const value = inputElement?.value?.trim() || ''; 
  if (!value) {
    this.result.dontTrigger = true;
    return;
  } 
  this.result.search_keyword = value;
}
    // if (!data.category) {
    //   Logger.error(
    //     "[AnalyticsUserActionEventObjectException] Category is required for uaevent (L'Oréal guideline)",
    //     data
    //   );
    //   throw new AnalyticsUserActionEventObjectException(
    //     "Category is required for uaevent (L'Oréal guideline)"
    //   );
    // }

    // if (!data.action) {
    //   Logger.error(
    //     "[AnalyticsUserActionEventObjectException] Action is required for uaevent (L'Oréal guideline)",
    //     data
    //   );
    //   throw new AnalyticsUserActionEventObjectException(
    //     "Action is required for uaevent (L'Oréal guideline)"
    //   );
    // }

    // if (!data.label) {
    //   Logger.error(
    //     "[AnalyticsUserActionEventObjectException] Label is required for uaevent (L'Oréal guideline)",
    //     data
    //   );
    //   throw new AnalyticsUserActionEventObjectException(
    //     "Label is required for uaevent (L'Oréal guideline)"
    //   );
    // }

    this.result.ecommerce = data.ecommerce || undefined;
  }

  set category(category) {
    if (category != 'Ecommerce') {
      this.result.eventCategory = this.setProperty(category);
    } else {
      this.result.eventCategory = 'Ecommerce';
    }
  }

  get category() {
    return this.result.eventCategory;
  }

  set action(action) {
    this.result.eventAction = this.setProperty(action);
  }

  get action() {
    return this.result.eventAction;
  }

  set event_name(value) {
    this.result.event_name = this.setProperty(value);
  }

  get event_name() {
    return this.result.event_name;
  }

  set article_name(value) {
    this.result.article_name = this.setProperty(value);
  }

  get article_name() {
    return this.result.article_name;
  }

  set module_name(value) {
    this.result.module_name = this.setProperty(value);
  }

  get module_name() {
    return this.result.module_name;
  }

  set service_name(value) {
    this.result.service_name = this.setProperty(value);
  }

  get service_name() {
    return this.result.service_name;
  }

  set service_category(value) {
    this.result.service_category = this.setProperty(value);
  }

  get service_category() {
    return this.result.service_category;
  }

  // uses only for VTO v1
  // should be removed after moving to VTO v2, DSF app
  set service_version(value) {
    this.result.service_version = this.setProperty(value);
  }

  get service_version() {
    return this.result.service_version;
  }

  set cta_name(value) {
    this.result.cta_name = this.setProperty(value);
  }

  get cta_name() {
    return this.result.cta_name;
  }
  set search_keyword(value) {
    this.result.search_keyword = this.setProperty(value);
  }

  get search_keyword() {
    return this.result.search_keyword;
  }

  set link_url(value) {
    this.result.link_url = this.setProperty(value);
  }

  get link_url() {
    return this.result.link_url;
  }

  set click_area(value) {
    this.result.click_area = this.setProperty(value);
  }

  get click_area() {
    return this.result.click_area;
  }

  set click_action(value) {
    this.result.click_action = this.setProperty(value);
  }

  get click_action() {
    return this.result.click_action;
  }

  set video_title(value) {
    this.result.video_title = this.setProperty(value);
  }

  get video_title() {
    return this.result.video_title;
  }

  set video_action(value) {
    this.result.video_action = this.setProperty(value);
  }

  get video_action() {
    return this.result.video_action;
  }

  set breadcrumb(value) {
    this.result.breadcrumb = this.setProperty(value);
  }

  get breadcrumb() {
    return this.result.breadcrumb;
  }

  set label(value) {
    this.result.eventLabel = this.setProperty(value);
  }

  get label() {
    return this.result.eventLabel;
  }
  set requestType(value) {
    this.result.requestType = this.setProperty(value);
  }

  get requestType() {
    return this.result.requestType;
  }

  set value(value) {
    this.result.eventValue = this.setProperty(value);
  }

  set ename(value) {
    this.result.event_name = this.setProperty(value);
  }

  get ename() {
    return this.result.event_name;
  }

  set store_name(value) {
    this.result.store_name = this.setProperty(value);
  }

  get store_name() {
    return this.result.store_name;
  }

  set detail(detail) {
    this.result.event_detail = this.setProperty(detail);
  }

  get detail() {
    return this.result.event_detail;
  }

  set product_info(value) {
    this.result.product_info = this.setProperty(value);
  }

  get product_info() {
    return this.result.product_info;
  }

  set product_tab(value) {
    this.result.product_tab = this.setProperty(value);
  }

  get product_tab() {
    return this.result.product_tab;
  }

  set step(value) {
    this.result.step = this.setProperty(value);
  }

  get step() {
    return this.result.step;
  }

  set filter_type(value) {
    this.result.filter_type = this.setProperty(value);
  }

  get filter_type() {
    return this.result.filter_type;
  }

  set filter_value(value) {
    this.result.filter_value = this.setProperty(value);
  }

  get filter_value() {
    return this.result.filter_value;
  }

  set social_network(value) {
    this.result.social_network = this.setProperty(value);
  }

  get social_network() {
    return this.result.social_network;
  }

  set social_action(value) {
    this.result.social_action = this.setProperty(value);
  }

  get social_action() {
    return this.result.social_action;
  }

  set event_detail(value) {
    this.result.event_detail = this.setProperty(value);
  }

  get event_detail() {
    return this.result.event_detail;
  }

  set productInfo(value) {
    this.result.product_info = this.setProperty(value);
  }

  get productInfo() {
    return this.result.product_info;
  }

  set productTab(value) {
    this.result.product_tab = this.setProperty(value);
  }

  get productTab() {
    return this.result.product_tab;
  }

  set referral(value) {
    this.result.referral = this.setProperty(value);
  }

  get referral() {
    return this.result.referral;
  }

  set form_name(value) {
    this.result.form_name = this.setProperty(value);
  }

  get form_name() {
    return this.result.form_name;
  }
}
